export const gtmEventTypes = {
  SUBMIT_LOGIN: 'FED-MYMAZDA-001',
  FAIL_LOGIN: 'FED-MYMAZDA-002',
}

export const gtmEvents = {
  [gtmEventTypes.SUBMIT_LOGIN]: ({isVin}) => ({
    type: gtmEventTypes.SUBMIT_LOGIN,
    event: 'reactjs.event',
    eventID: gtmEventTypes.SUBMIT_LOGIN,
    pageCategory: 'MyMazda',
    pageAction: `MyMazda Login - Enter VIN/Rego - Submitted "${isVin ? 'VIN': 'REGO'}"`,
  }),
  [gtmEventTypes.FAIL_LOGIN]: ({isVin}) => ({
    type: gtmEventTypes.FAIL_LOGIN,
    event: 'reactjs.event',
    eventID: gtmEventTypes.FAIL_LOGIN,
    pageCategory: 'MyMazda',
    pageAction: `MyMazda Login - Enter VIN/Rego - Failed Login "${isVin ? 'VIN': 'REGO'}"`,
  }),
}



// WEBPACK FOOTER //
// ./src/store/gtm-events/mymazda-login-duck.js